class DragData {
    constructor(gapChoiceIdentifier, hotspotIdentifier) {
        this.gapChoiceIdentifier = gapChoiceIdentifier;
        this.hotspotIdentifier = hotspotIdentifier;
    }

    static parseFromEvent(event) {
        try {
            const { gapChoiceIdentifier, hotspotIdentifier } = JSON.parse(event.dataTransfer.getData('text'));
            return new DragData(gapChoiceIdentifier, hotspotIdentifier);
        } catch (error) {
            return new DragData();
        }
    }

    static setOnEvent(event, gapChoiceIdentifier, hotspotIdentifier) {
        event.dataTransfer.setData(
            'text',
            JSON.stringify({ gapChoiceIdentifier, hotspotIdentifier })
        );
    }
}

export default DragData;
